import styled from "@emotion/styled";

type IsActiveProps = {
    IsActive: boolean;
}

export const RichTextContainer = styled.div`
  min-height: 300px;
  width: 100%;
  padding: 10px;
  margin: 10px;
`;

export const HeaderContainer = styled.div`
  text-align: center;
  font-size: 24px;
`;

export const RichEditorRoot = styled.div`
  background: #fff;
  border: 1px solid #ddd;
  font-family: "Georgia", serif;
  font-size: 14px;
  padding: 15px;
`;

export const RichEditorControls = styled.div`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  margin-bottom: 5px;
  user-select: none;
`;

export const RichEditorStyledButton = styled.span<IsActiveProps>`
color: ${(props: IsActiveProps) => (props.IsActive ? '#5890ff' : '#999')};
  cursor: pointer;
  margin-right: 16px;
  padding: 2px 0;
  display: inline-block;
`;

export const RichEditorActiveButton = styled.span`
  color: #5890ff;
`;
